import { useCallback, useEffect, useState } from 'react';
import { useHash } from 'hooks/use-hash';
import { TimesheetReportTab } from './types';

export const useTab = (allowedTab: TimesheetReportTab[]) => {
  const [tab, setTab, getNextTab] = useHash<TimesheetReportTab>({
    from: (value) => {
      return allowedTab.includes(value.tab as TimesheetReportTab)
        ? (value.tab as TimesheetReportTab)
        : allowedTab[0];
    },
    to: (nextTab) => {
      return { tab: nextTab as string };
    },
  });

  const [selectedTab, _setTab] = useState<TimesheetReportTab>(tab);

  useEffect(() => {
    if (tab !== selectedTab) {
      _setTab(tab);
    }
  }, [tab, selectedTab, _setTab]);

  const setSelectedTab = useCallback(
    (nextTab: TimesheetReportTab) => {
      setTab(nextTab);
    },
    [setTab],
  );

  return {
    selectedTab,
    setSelectedTab,
    getNextTab,
  };
};
